const routes = [];
const require_modules = require.context('./../modules/', true, /routes.js/);

require_modules.keys().forEach(filename => {
  routes.push(...require_modules(filename).default);
});

export default routes;
